// Shared date defaults for Analytics pages.
// Returns the last 30 days as { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' }.

const _iso = (d) => d.toISOString().slice(0, 10);

export const last30Days = () => {
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - 30);
  return { from: _iso(from), to: _iso(to) };
};

// Given a [from, to] window, return the immediately-prior window of the same length.
// Used by the "vs previous period" comparison badges on KPI cards.
export const previousPeriod = (fromStr, toStr) => {
  if (!fromStr || !toStr) return { from: "", to: "" };
  const from = new Date(fromStr + "T00:00:00");
  const to = new Date(toStr + "T00:00:00");
  const days = Math.max(1, Math.round((to - from) / (1000 * 60 * 60 * 24)) + 1);
  const prevTo = new Date(from);
  prevTo.setDate(prevTo.getDate() - 1);
  const prevFrom = new Date(prevTo);
  prevFrom.setDate(prevFrom.getDate() - (days - 1));
  return { from: _iso(prevFrom), to: _iso(prevTo) };
};

// Compute a delta % vs prior. Returns { pct, direction }.
//   pct: integer percent change (rounded), or null if prior is 0 and current is 0.
//   direction: 'up' | 'down' | 'flat'
export const computeDelta = (current, prior) => {
  const c = Number(current) || 0;
  const p = Number(prior) || 0;
  if (c === 0 && p === 0) return { pct: null, direction: "flat" };
  if (p === 0) return { pct: null, direction: c > 0 ? "up" : "flat" };
  const pct = Math.round(((c - p) / p) * 100);
  const direction = pct > 0 ? "up" : pct < 0 ? "down" : "flat";
  return { pct, direction };
};
